import React, { useEffect, useState, useRef } from 'react';
import axios from '../../utils/axiosInstance';
import { Link } from 'react-router-dom';
import { FaEdit, FaTrash, FaEye, FaFilter, FaFileImport, FaFileExport, FaExchangeAlt } from 'react-icons/fa';
import CommonTransferForm from '../../components/commonComponent/CommonTransferForm';
import ChapterSelectionModal from '../../components/commonComponent/ChapterSelectionModal';
import { toastSuccess, toastError } from '../../utils/alertHelper';
import UserFilters from '../../components/commonComponent/UserFilters';
import Select from 'react-select';
import { hasPermission } from '../../utils/permissionHelper'; // <-- Add this import

const UserIndex = () => {
  
  const columnDropdownRef = useRef(null);
  const [showColumnFilters, setShowColumnFilters] = useState(false);
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const user = JSON.parse(localStorage.getItem("user")); // logged in user
  const [userType, setUserType] = useState("Member");
  const importInputRef = useRef();
  const handleExport = async () => {
  try {
  const params = {
  search: searchQuery,
  clusterId: filters.clusterId,
  chapterId: filters.chapterId,
  cityId: filters.cityId,
  stateId: filters.stateId,
  businessCategoryId: filters.businessCategoryId,
  businessSubCategoryId: filters.businessSubCategoryId,
  startDate: filters.startDate,
  endDate: filters.endDate,
  userType: 'Member',
  };


const response = await axios.get('/api/user/export-excel', {
params,
responseType: 'blob',
});


// Filename from header if available
const disposition = response.headers['content-disposition'];
let filename = 'users.xlsx';
if (disposition && disposition.includes('filename=')) {
filename = disposition.split('filename=')[1].replace(/"/g, '');
}


const url = window.URL.createObjectURL(new Blob([response.data]));
const link = document.createElement('a');
link.href = url;
link.setAttribute('download', filename);
document.body.appendChild(link);
link.click();
link.remove();


toastSuccess('Export started');
} catch (err) {
console.error('Export failed:', err);
toastError('Failed to export data');
}
};
  // Handle import modal open/close
  const handleOpenImportModal = () => {
    setImportModalVisible(true);
    setImportFile(null);
  };
  const handleCloseImportModal = () => {
    setImportModalVisible(false);
    setImportFile(null);
  };

  // Handle file change
  const handleImportFileChange = (e) => {
    setImportFile(e.target.files[0]);
  };

  // Handle import submit
  const handleImportSubmit = async (e) => {
  e.preventDefault();
  if (!importFile) {
    toastError('Please select a file');
    return;
  }

  const formData = new FormData();
  formData.append('file', importFile);
  formData.append('userType', 'Member');

    // try {
    //   const res = await axios.post(`/api/user/import-excel?userType=${userType}`, formData);
    //   if (res.data.status === 'partial') {
    //     toastError('Some rows failed to import.');
    //     // Convert failed rows to CSV for download
    //     const csvContent =
    //       'data:text/csv;charset=utf-8,' +
    //       res.data.failed.map(e => e.join(',')).join('\n');
    //     const encodedUri = encodeURI(csvContent);
    //     const link = document.createElement('a');
    //     link.setAttribute('href', encodedUri);
    //     link.setAttribute('download', 'failed_rows.csv');
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //   } else {
    //     toastSuccess('File imported successfully!');
    //   }
    //   handleCloseImportModal();
    //   fetchUsers(currentPage, searchQuery, filters);
    // } catch (err) {
    //   toastError('Import failed');
    // }

    try {
      const res = await axios.post(`/api/user/import-excel?userType=${userType}`, formData);
      if (res.data.Status) {
       //If res.data.failedCount contains the Excel path
        if (res.data.exportExcelUrl && res.data.failedCount > 0) {
          console.log("hnijgn");
          // Ensure no leading slash issues
          const failedFileUrl = process.env.REACT_APP_API_URL + res.data.exportExcelUrl; // handles with/without leading slash
          const link = document.createElement('a');
          link.href = failedFileUrl;
          link.setAttribute('download', 'failed_rows.xlsx');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
        toastError('Some rows failed to import.');
      } else {
        toastSuccess('File imported successfully!');
      }
      handleCloseImportModal();
      fetchUsers(currentPage, searchQuery, filters);
    } catch (err) {
      toastError('Import failed');
    }

  };


  // Download sample file
  const handleDownloadSample = () => {
    window.open(process.env.REACT_APP_DEMO_IMPORT_EXCLE_URL, '_blank');
  };
  const [transferModalVisible, setTransferModalVisible] = useState(false);
  const [chapterSelectionModalVisible, setChapterSelectionModalVisible] = useState(false);
  const [transferUser, setTransferUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showFilters, setShowFilters] = useState(false);

  // Create User Modal State
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [createFormValues, setCreateFormValues] = useState({
    firstName: '',
    lastName: '',
    middleName: '',
    mobileNumber: '',
    email: '',
    business_name: '',
    business_category: '',
    business_sub_category: '',
    joiningDate: new Date().toISOString().split('T')[0], // default today
    userType: 'Member',
    chapter: '',
    source: '',
    invitedByUser: '',
    plan: '',
    fees: '',
  });               
  const [plans, setPlans] = useState([]);

// Fetch plans only when modal opens
useEffect(() => {
  const fetchPlans = async () => {
    try {
      const res = await axios.get('/api/plan');
      setPlans(
        res.data.plans?.map(p => ({
          value: p._id,
          label: p.name
        })) || []
      );
    } catch (err) {
      console.error('Failed to fetch plans', err);
      setPlans([]);
    }
  };

  if (showCreateModal) fetchPlans();
}, [showCreateModal]);
  const [createLoading, setCreateLoading] = useState(false);

  // Dropdowns for business category/subcategory
  const [businessDropdowns, setBusinessDropdowns] = useState({
    businessCategories: [],
    businessSubCategories: [],
  });

  // Fetch business category/subcategory for modal
  useEffect(() => {
    const fetchBusinessDropdowns = async () => {
      try {
        const [catRes, subCatRes] = await Promise.all([
          axios.get('/admin/api/businessCategory'),
          axios.get('/admin/api/businessSubCategory'),
        ]);
        setBusinessDropdowns({
          businessCategories: catRes.data?.businessCategories?.map(c => ({
            value: c._id,
            label: c.name,
          })) || [],
          businessSubCategories: subCatRes.data?.businessSubCategories?.map(sc => ({
            value: sc._id,
            label: sc.name,
           category: sc.category,
          })) || [],
        });
      } catch (err) {
        setBusinessDropdowns({ businessCategories: [], businessSubCategories: [] });
      }
    };
    if (showCreateModal) fetchBusinessDropdowns();
  }, [showCreateModal]);
 const handleBusinessCategoryChange = async (selectedOption) => {
  // selectedOption is the whole { value, label } object from react-select
  const categoryId = selectedOption ? selectedOption.value : '';

  // 1. Set the selected category in form and clear subcategory
  setCreateFormValues(v => ({
    ...v,
    business_category: categoryId,
    business_sub_category: [], // always reset subcategory!
  }));

  // 2. Fetch subcategories for this category
  if (categoryId) {
    try {
      const response = await axios.get(`/admin/api/businessSubCategory?categoryId=${categoryId}`);
      setBusinessDropdowns(d => ({
        ...d,
        businessSubCategories: response.data?.businessSubCategories?.map(sc => ({
          value: sc._id,
          label: sc.name,
          category: sc.category,
        })) || [],
      }));
    } catch (err) {
      setBusinessDropdowns(d => ({ ...d, businessSubCategories: [] }));
    }
  } else {
    setBusinessDropdowns(d => ({ ...d, businessSubCategories: [] }));
  }
};
  // Close column dropdown when clicking outside
  useEffect(() => {
    if (!showColumnFilters) return;
    const handleClickOutside = (event) => {
      if (columnDropdownRef.current && !columnDropdownRef.current.contains(event.target)) {
        setShowColumnFilters(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showColumnFilters]);

  const [filters, setFilters] = useState({
  clusterId: '',
  chapterId: '',
  cityId: '',
  stateId: '',
  businessCategoryId: '',
  businessSubCategoryId: '',
  startDate: '',
  endDate: '',
  });

  const [dropdowns, setDropdowns] = useState({
    clusters: [],
    chapters: [],
    cities: [],
    states: [],
    businessCategories: [],
    businessSubCategories: [],
  });

  const getInitialLimit = () => {
    const stored = localStorage.getItem('user_page_limit');
    return stored ? parseInt(stored) : 10;
  };
  const [limit, setLimit] = useState(getInitialLimit());

  const allColumns = [
    { key: 'memberId', label: 'Member ID' },
    { key: 'firstName', label: 'First Name' },
    { key: 'middleName', label: 'Middle Name' },
    { key: 'lastName', label: 'Last Name' },
    { key: 'email', label: 'Email' },
    { key: 'mobileNumber', label: 'Mobile Number' },
    { key: 'chapter', label: 'Chapter' },
    { key: 'city', label: 'City' },
    { key: 'joiningDate', label: 'Joining Date' },
    { key: 'businessName', label: 'Business Name' },
    { key: 'businessCategory', label: 'Business Category' },
    { key: 'businessSubCategory', label: 'Business SubCategory' },
  ];

  const getInitialVisibleColumns = () => {
    const stored = localStorage.getItem('user_visible_columns');
    return stored ? JSON.parse(stored) : [
      'memberId',
      'firstName',
      'middleName',
      'lastName',
      'email',
      'mobileNumber',
      'cluster',
      'city',
      'joiningDate',
      'businessName',
      'businessEmail',
      'businessMobileNumber',
      'businessCategory',
      'businessSubCategory'
    ];
  };
  const [visibleColumns, setVisibleColumns] = useState(getInitialVisibleColumns);
  const [columnDropdownOpen, setColumnDropdownOpen] = useState(true);

  useEffect(() => {
    fetchDropdownOptions();
  }, []);

  useEffect(() => {
    localStorage.setItem('user_page_limit', limit);
  }, [limit]);

  useEffect(() => {
    localStorage.setItem('user_visible_columns', JSON.stringify(visibleColumns));
  }, [visibleColumns]);

  useEffect(() => {
    fetchUsers(currentPage, searchQuery, filters);
  }, [currentPage, searchQuery, filters, limit]);

  const fetchDropdownOptions = async () => {
    try {
      const [clustersRes,
        chaptersRes,
        citiesRes,
        statesRes,
        catRes,
        subCatRes,] = await Promise.all([
        axios.get('/admin/api/clusters/all'),
        axios.get('/admin/api/chapters/all'),
        axios.get('/admin/api/city'),
        axios.get('/admin/api/state'),
        axios.get('/admin/api/businessCategory'),
        axios.get('/admin/api/businessSubCategory'),
      ]);

      setDropdowns({
        clusters:
          clustersRes.data?.cluster?.map((c) => ({ value: c._id, label: c.name })) || [],
        chapters:
          chaptersRes.data?.chapter?.map((ch) => ({ value: ch._id, label: ch.name })) || [],
        cities:
          citiesRes.data?.cities?.map((ci) => ({ value: ci._id, label: ci.name })) || [],
        states:
          statesRes.data?.states?.map((st) => ({ value: st._id, label: st.name })) || [],
        businessCategories:
          catRes.data?.businessCategories?.map((c) => ({ value: c._id, label: c.name })) || [],
        businessSubCategories:
          subCatRes.data?.businessSubCategories?.map((sc) => ({ value: sc._id, label: sc.name })) || [],
      });
    
    } catch (err) {
      toastError('Failed to load filter dropdowns');
    }
  };

  const fetchUsers = async (page = 1, search = '', filtersData = filters) => {
    try {
      const params = new URLSearchParams({
        userType: 'Member',
        page,
        limit,
      });

      if (search && search.trim()) {
        params.append('search', search.trim());
      }
       if (filtersData.clusterId) params.append('clusterId', filtersData.clusterId);
    if (filtersData.chapterId) params.append('chapterId', filtersData.chapterId);
    if (filtersData.cityId) params.append('cityId', filtersData.cityId);
    if (filtersData.stateId) params.append('stateId', filtersData.stateId);
    if (filtersData.businessCategoryId) params.append('businessCategoryId', filtersData.businessCategoryId);
    if (filtersData.businessSubCategoryId) params.append('businessSubCategoryId', filtersData.businessSubCategoryId);
    if (filtersData.startDate) params.append('startDate', filtersData.startDate);
    if (filtersData.endDate) params.append('endDate', filtersData.endDate);
      

      const res = await axios.get(`/api/user?${params.toString()}`);
      const { users = [], totalCount = 0 } = res.data;
      setUsers(users);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      toastError('Failed to fetch users');
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/user/${id}`);
      toastSuccess('User deleted successfully!');
      setCurrentPage(1);
      fetchUsers(1, searchQuery, filters);
    } catch (err) {
      toastError('Failed to delete user');
    }
  };

  // Update handleFilterChange to also set page to 1 and fetch users
  const handleFilterChange = (field, value) => {
    setFilters(prev => {
      const updated = { ...prev, [field]: value };
      setCurrentPage(1);
      fetchUsers(1, searchQuery, updated);
      return updated;
    });
  };

  const clearFilters = () => {
    setFilters({
    clusterId: '',
    chapterId: '',
    cityId: '',
    stateId: '',
    businessCategoryId: '',
    businessSubCategoryId: '',
    startDate: '',
    endDate: '',
    });
    setSearchQuery('');
    setCurrentPage(1);
  };

  const handleOpenChapterSelection = () => {
    setTransferModalVisible(false);
    setChapterSelectionModalVisible(true);
  };

  const handleChapterTransfer = async (selectedChapterIds) => {
    try {
      if (!transferUser || selectedChapterIds.length === 0) {
        toastError('Please select at least one chapter');
        return;
      }
      const transferData = {
        user: transferUser._id,
        newchapter: selectedChapterIds.join(', ')
      };

      await axios.post('/api/transfer', transferData);
      toastSuccess('User transferred successfully!');
      fetchUsers(currentPage, searchQuery, filters);
      setChapterSelectionModalVisible(false);
      setTransferUser(null);
    } catch (err) {
      toastError('Failed to transfer user');
    }
  };

  // Handle create user submit
 const handleCreateUser = async () => {
  // Mobile number validation
  const mobile = createFormValues.mobileNumber;
  if (
    !mobile ||
    !/^\d{10}$/.test(mobile)
  ) {
    toastError('Mobile number must be exactly 10 digits and numeric only.');
    setCreateLoading(false);
    return;
  }
  setCreateLoading(true);

  try {
    const payload = {
      firstName: createFormValues.firstName,
      lastName: createFormValues.lastName,
      middleName: createFormValues.middleName,
      mobileNumber: createFormValues.mobileNumber,
      email: (createFormValues.email || '').toLowerCase(), // <-- lowercase email
      joiningDate: createFormValues.joiningDate,
      chapter: createFormValues.chapter,
      userType: 'Member',
      source: createFormValues.source,
      invitedByUser: createFormValues.invitedByUser,
      business: [
        {
          name: createFormValues.business_name,
          category: createFormValues.business_category,
          subCategory: Array.isArray(createFormValues.business_sub_category)
            ? createFormValues.business_sub_category.join(',')
            : createFormValues.business_sub_category || '',
        },
      ],
      plan: createFormValues.plan,
      fees: createFormValues.fees,
    };

    const res = await axios.post('/api/user/new-create', payload);

    if (res.data.Status === 1) {
      // ✅ Success
      toastSuccess(res.data.Message || "User created successfully!");
      setShowCreateModal(false);

      // Reset form
      setCreateFormValues({
        firstName: '',
        lastName: '',
        middleName: '',
        mobileNumber: '',
        email: '',
        business_name: '',
        business_category: '',
        business_sub_category: [],
        joiningDate: new Date().toISOString().split('T')[0],
        chapter: '',
        source: '',
        invitedByUser: '',
        plan: '',
        fees: '',
      });

      setCurrentPage(1);
      fetchUsers(1, searchQuery, filters);

    } else {
      // ❌ Failure cases
      if (res.data.Message === "User already exists") {
        toastError("A user with this email or mobile number already exists.");
      } else if (Array.isArray(res.data.errors) && res.data.errors.length > 0) {
        toastError(res.data.errors[0]);
      } else {
        toastError(res.data.Message || "Failed to create user");
      }
    }

  } catch (err) {
    const Message =
      err.response?.data?.Message ||
      err.response?.data?.error ||
      'Failed to create user';
    toastError(Message);
  }

  setCreateLoading(false);
};

 if (!hasPermission(user, "Member", "Read")) {
    return (
      <div className="container py-4 text-center">
        <p className="text-danger fw-bold">
          🚫 You don’t have permission to view Members.
        </p>
      </div>
    );
  }
  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0 text-dark"> Member</h3>
      </div>

      <div className="d-flex align-items-center gap-2 flex-wrap justify-content-end">
        <input
          type="text"
          className="form-control form-control-sm"
          style={{ width: 200 }}
          placeholder="Search User..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />

        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{
            backgroundColor: showFilters ? '#C44C23' : 'transparent',
            color: showFilters ? '#fff' : '#C44C23',
            border: '1px solid #C44C23',
          }}
          onClick={() => setShowFilters(!showFilters)}
        >
          <FaFilter />
        </button>

         <button
                  className="btn btn-sm d-flex align-items-center gap-1 btn-success"
                  type="button"
                  onClick={handleExport}
                >
                  <FaFileExport /> Export
                </button>
        
                <button
                  className="btn btn-sm d-flex align-items-center gap-1 btn-success"
                  type="button"
                  onClick={handleOpenImportModal}
                >
                  <FaFileImport /> Import
                </button> 
        {/* Import Modal */}
        {importModalVisible && (
          <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.3)' }} tabIndex="-1">
            <div className="modal-dialog">
              <form className="modal-content" onSubmit={handleImportSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">Import Users</h5>
                  <button type="button" className="btn-close" onClick={handleCloseImportModal}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">Select File</label>
                    <input type="file" accept=".csv,.xlsx" className="form-control" ref={importInputRef} onChange={handleImportFileChange} />
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-info" onClick={handleDownloadSample}>Download Sample File</button>
                  <button type="submit" className="btn btn-success">Import</button>
                </div>
              </form>
            </div>
          </div>
        )}

        <button
          className="btn btn-sm d-flex align-items-center gap-1"
          style={{
            backgroundColor: showColumnFilters ? '#C44C23' : 'transparent',
            color: showColumnFilters ? '#fff' : '#C44C23',
            border: '1px solid #C44C23',
          }}
          onClick={() => setShowColumnFilters(!showColumnFilters)}
        >
          <FaEye />
        </button>
      </div>

      {/* Create User Modal (custom, side by side fields) */}
      {showCreateModal && (
        <div className="modal fade show" style={{ display: 'block', background: 'rgba(0,0,0,0.3)' }} tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <form
              className="modal-content"
              onSubmit={e => {
                e.preventDefault();
                handleCreateUser();
              }}
            >
              <div className="modal-header">
                <h5 className="modal-title">Member Registration</h5>
                <button type="button" className="btn-close" onClick={() => setShowCreateModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">First Name<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={createFormValues.firstName}
                      onChange={e => setCreateFormValues(v => ({ ...v, firstName: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Middle Name<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={createFormValues.middleName}
                      onChange={e => setCreateFormValues(v => ({ ...v, middleName: e.target.value }))}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Last Name<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={createFormValues.lastName}
                      onChange={e => setCreateFormValues(v => ({ ...v, lastName: e.target.value }))}
                      required
                    />
                  </div>
                </div>
                <hr className="my-2" />
                  <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Mobile Number<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={createFormValues.mobileNumber}
                      onChange={e => setCreateFormValues(v => ({ ...v, mobileNumber: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Email ID<span className="text-danger">*</span></label>
                    <input
                      type="email"
                      className="form-control"
                      value={createFormValues.email}
                      onChange={e => setCreateFormValues(v => ({ ...v, email: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Joining Date<span className="text-danger">*</span></label>
                    <input
                      type="date"
                      className="form-control"
                      value={createFormValues.joiningDate}
                      onChange={e => setCreateFormValues(v => ({ ...v, joiningDate: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                  <label className="form-label">Chapter<span className="text-danger">*</span></label>
                  <select
                    className="form-select"
                    value={createFormValues.chapter}
                    onChange={e => setCreateFormValues(v => ({ ...v, chapter: e.target.value }))}
                    required
                  >
                    <option value="">Select Chapter</option>
                    {dropdowns.chapters.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </div>
                </div>
                <hr className="my-2" />
                 <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">Business Name<span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      value={createFormValues.business_name}
                      onChange={e => setCreateFormValues(v => ({ ...v, business_name: e.target.value }))}
                      required
                    />
                  </div>
                  <div className="col-md-4">
                  <label className="form-label">
                    Business Category<span className="text-danger">*</span>
                  </label>
                 <Select
                    options={businessDropdowns.businessCategories}
                    placeholder="Select Category"
                    value={
                      businessDropdowns.businessCategories.find(
                        (opt) => opt.value === createFormValues.business_category
                      ) || null
                    }
                    onChange={handleBusinessCategoryChange}
                    classNamePrefix="select"
                    required
                  />
                </div>
                 <div className="col-md-4">
                  <label className="form-label">
                    Business Sub Category<span className="text-danger">*</span>
                  </label>
                  <Select
                    options={businessDropdowns.businessSubCategories}
                    isMulti
                    placeholder="Select Sub Category"
                    value={businessDropdowns.businessSubCategories.filter(opt =>
                      (createFormValues.business_sub_category || []).includes(opt.value)
                    )}
                    onChange={selectedOptions => {
                      setCreateFormValues(v => ({
                        ...v,
                        business_sub_category: selectedOptions ? selectedOptions.map(opt => opt.value) : [],
                      }));
                    }}
                    classNamePrefix="select"
                    required
                  />
                </div>
                   <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label">
                      Invite By <span className="text-danger">*</span>
                    </label>
                    <Select
                      options={[
                        { value: 'socialMedia', label: 'Social Media' },
                        { value: 'user', label: 'User' }
                      ]}
                      placeholder="Select Invite By"
                      value={[
                        { value: 'socialMedia', label: 'Social Media' },
                        { value: 'user', label: 'User' }
                      ].find(opt => opt.value === createFormValues.source) || null}
                      onChange={selectedOption => {
                        setCreateFormValues(v => ({
                          ...v,
                          source: selectedOption ? selectedOption.value : '',
                          invitedByUser: '' // reset if changed
                        }));
                      }}
                      classNamePrefix="select"
                      required
                    />
                  </div>
                  {createFormValues.source === 'user' && (
                    <div className="col-md-4">
                      <label className="form-label">
                        Invited User <span className="text-danger">*</span>
                      </label>
                      <Select
                        options={users.map(u => ({ value: u._id, label: `${u.firstName} ${u.lastName}` }))}
                        placeholder="Select User"
                        value={
                          users
                            .map(u => ({ value: u._id, label: `${u.firstName} ${u.lastName}` }))
                            .find(opt => opt.value === createFormValues.invitedByUser) || null
                        }
                        onChange={selectedOption => {
                          setCreateFormValues(v => ({
                            ...v,
                            invitedByUser: selectedOption ? selectedOption.value : ''
                          }));
                        }}
                        classNamePrefix="select"
                        required
                      />
                    </div>
                  )}
                  {/* <div className="col-md-4">
                                      <label className="form-label">Fees<span className="text-danger">*</span></label>
                                      <input
                                        type="fees"
                                        className="form-control"
                                        value={createFormValues.fees}
                                        onChange={e => setCreateFormValues(v => ({ ...v, fees: e.target.value }))}
                                        required
                                      />
                                    </div> */}
                   <div className="col-md-6">
                                    <label className="form-label">
                                      Plans <span className="text-danger">*</span>
                                    </label>
                                    <Select
                                      options={plans}
                                      placeholder="Select Plans"
                                      value={plans.find(opt => opt.value === createFormValues.plan) || null}
                                      onChange={selectedOption => {
                                        setCreateFormValues(v => ({
                                          ...v,
                                          plan: selectedOption ? selectedOption.value : '',
                                        }));
                                      }}
                                      classNamePrefix="select"
                                      required
                                    />
                                    </div> 
                 </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowCreateModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="btn btn-success" disabled={createLoading}>
                  {createLoading ? "Save..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {showFilters && (
        <UserFilters
          filters={filters}
          dropdowns={dropdowns}
          onFilterChange={handleFilterChange}
          onClearFilters={clearFilters}
        />
      )}

      {showColumnFilters && (
        <div className="mb-2 text-end position-relative" style={{ minWidth: 220 }} ref={columnDropdownRef}>
          <div
            className="dropdown-menu show p-3"
            style={{
              maxHeight: 250,
              overflowY: 'auto',
              right: 0,
              left: 'auto',
              position: 'absolute',
              zIndex: 1050,
              width: 'max-content',
              minWidth: 220,
            }}
          >
            {allColumns.filter(col => col.key !== undefined && col.label !== undefined).map(col => (
              <div key={col.key} className="form-check mb-1">
                <input
                  type="checkbox"
                  id={`col-filter-${col.key}`}
                  className="form-check-input"
                  checked={visibleColumns.includes(col.key)}
                  onChange={e => {
                    if (e.target.checked) {
                      setVisibleColumns(prev => {
                        // Insert col.key at the correct location
                        const allKeys = allColumns.map(c => c.key);
                        const newCols = [...prev, col.key];
                        // Remove duplicates
                        const uniqueCols = Array.from(new Set(newCols));
                        // Sort based on allColumns order
                        uniqueCols.sort((a, b) => allKeys.indexOf(a) - allKeys.indexOf(b));
                        return uniqueCols;
                      });
                    } else {
                      setVisibleColumns(prev => prev.filter(k => k !== col.key));
                    }
                  }}
                />
                <label htmlFor={`col-filter-${col.key}`} className="form-check-label">
                  {col.label}
                </label>
              </div>
            ))}
          </div>
        </div>
      )}

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0 text-dark">All Member</h5>
          {hasPermission(user, "Member", "Create") && (
          <button
            className="btn btn-sm btn-success"
            onClick={() => setShowCreateModal(true)}
          >
            + Add New Member
          </button>
          )}
        </div>

        {/* Table with horizontal scroll only for table */}
        <div className="table-responsive" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
          <div className="card-body p-0">
            <table className="table table-bordered table-sm mb-0">
              <thead className="table-light">
                <tr>
                  <th className="py-1">Sr no.</th>
                  {visibleColumns
                    .filter(key => {
                      const col = allColumns.find(c => c.key === key);
                      return col && col.label;
                    })
                    .map(key => {
                      const col = allColumns.find(c => c.key === key);
                      return <th key={key} className="py-1">{col.label}</th>;
                    })}
                  <th className="py-1">Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  users.map((u, idx) => (
                    <tr key={u._id}>
                      <td>{(currentPage - 1) * limit + idx + 1}</td>
                      {visibleColumns.map(key => {
                        const col = allColumns.find(c => c.key === key);
                        if (!col || !col.label) return null;
                        let value = '';
                        if (key === 'memberId') {
                          value = u.memberId;
                          // Render memberId as a link to the user view page
                          return (
                            <td key={key}>
                              <Link
                                to={`/user/view/${u._id}`}
                                style={{ color: '#C44C23', textDecoration: 'underline', cursor: 'pointer' }}
                              >
                                {value || '-'}
                              </Link>
                            </td>
                          );
                        }
                        else if (key === 'firstName') {
                          value = u.firstName;
                          return (
                            <td key={key}>
                              {value || '-'}
                            </td>
                          );
                        } else if (key === 'middleName') value = u.middleName;
                        else if (key === 'lastName') value = u.lastName;
                        else if (key === 'email') value = u.email;
                        else if (key === 'mobileNumber') value = u.mobileNumber;
                        else if (key === 'chapter') value = u.chapter?.[0]?.name;
                        else if (key === 'city') value = u.city?.name;
                        else if (key === 'joiningDate') value = u.joiningDate ? new Date(u.joiningDate).toLocaleDateString() : (u.createdAt ? new Date(u.createdAt).toLocaleDateString() : '-');
                        else if (key === 'businessName') value = u.business?.[0]?.name;
                        else if (key === 'businessCategory') value = u.business?.[0]?.category?.name;
                        else if (key === 'businessSubCategory') {value = u.business?.[0]?.subCategory?.length > 0? u.business[0].subCategory.map(sc => sc.name).join(', ') : '-';}
                        return <td key={key}>{value || '-'}</td>;
                      })}
                      <td>
                          {hasPermission(user, "Member", "Delete") && (
                        <button
                          type="button"
                          className="btn btn-sm me-1 py-0 px-2 fs-6 lh-sm shadow-none border-0 text-danger"
                          onClick={() => {
                            setTransferUser(u);
                            setTransferModalVisible(true);
                          }}
                        >
                          <FaExchangeAlt />
                        </button>
                       )} 
                      {hasPermission(user, "Member", "Edit") && (
                      <Link to={`/user/edit/${u._id}`}
                        className="btn btn-sm me-1 py-0 px-2 fs-6 lh-sm shadow-none border-0 text-primary-custom"
                        title="Edit"
                      >
                        <FaEdit size={14} />
                      </Link>
                      )}
                        {/* CommonTransferForm Modal */}
                        <CommonTransferForm
                          visible={transferModalVisible}
                          onCancel={() => {
                            setTransferModalVisible(false);
                            setTransferUser(null);
                          }}
                          onSubmit={handleOpenChapterSelection}
                          selectedUser={transferUser}
                        />

                        {/* Chapter Selection Modal */}
                        <ChapterSelectionModal
                          visible={chapterSelectionModalVisible}
                          onCancel={() => {
                            setChapterSelectionModalVisible(false);
                            setTransferUser(null);
                          }}
                          onConfirm={handleChapterTransfer}
                          chapters={dropdowns.chapters}
                          selectedUser={transferUser}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={visibleColumns.length + 2} className="text-center">No users found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>


        {/* Control Row and Pagination in one row */}
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 pb-2 pt-2">
          <div>
            <select
              className="form-select form-select-sm"
              style={{ width: 'auto' }}
              value={limit}
              onChange={e => {
                setLimit(Number(e.target.value));
                setCurrentPage(1);
              }}
            >
              {[10, 25, 50, 100].map(val => (
                <option key={val} value={val}>{val}</option>
              ))}
            </select>
          </div>
          <div className="flex-grow-1"></div>
          {totalPages > 1 && (
            <div className="d-flex justify-content-end align-items-center gap-2">
              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                &laquo;
              </button>

              {(() => {
                const pages = [];
                const maxVisiblePages = 3;

                // Always show first page
                pages.push(
                  <button
                    key={1}
                    className={`btn btn-sm page-btn ${currentPage === 1 ? 'active' : ''}`}
                    onClick={() => setCurrentPage(1)}
                  >
                    1
                  </button>
                );

                // Show ellipsis if needed before current page range
                if (currentPage > maxVisiblePages + 1) {
                  pages.push(
                    <span key="ellipsis1" className="px-2">
                    ...
                    </span>
                  );
                }

                // Show pages around current page
                const startPage = Math.max(2, currentPage - 1);
                const endPage = Math.min(totalPages - 1, currentPage + 1);

                for (let page = startPage; page <= endPage; page++) {
                  if (page !== 1 && page !== totalPages) {
                    pages.push(
                      <button
                        key={page}
                        className={`btn btn-sm page-btn ${currentPage === page ? 'active' : ''}`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    );
                  }
                }

                // Show ellipsis if needed after current page range
                if (currentPage < totalPages - maxVisiblePages) {
                  pages.push(
                    <span key="ellipsis2" className="px-2">
                    ...
                    </span>
                  );
                }

                // Always show last page if there's more than one page
                if (totalPages > 1) {
                  pages.push(
                    <button
                      key={totalPages}
                      className={`btn btn-sm page-btn ${currentPage === totalPages ? 'active' : ''}`}
                      onClick={() => setCurrentPage(totalPages)}
                    >
                      {totalPages}
                    </button>
                  );
                }

                return pages;
              })()}

              <button
                className="btn btn-sm btn-outline-secondary"
                disabled={currentPage === totalPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                &raquo;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
            
export default UserIndex;

